




































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import DateHandler from '@/shared/utils/date-format';
import { renderJsonHtml } from '@/shared/utils/json-html-helper';
import ErrorMonitorTag from '@/shared/utils/error-monitor-tag';
import ErrorMonitor from '@/domain/error-monitor/entity/error-monitor.entity';
import ErrorMonitorEnum from '@/domain/error-monitor/error-monitor-enum';
import ErrorMonitorService from '@/domain/error-monitor/service/error-monitor.service';

@Component({
  filters: {
    renderJsonHtml,
    formatDate(value: string) {
      return DateHandler.fullDateAndTime(value);
    },
  },
})

export default class ErrorMonitorDetailed extends Vue {
  @Prop({ type: Boolean, default: false }) showModal!: boolean;

  @Prop({ required: true }) id!: string;

  renderJsonHtml = renderJsonHtml;

  errorMonitor: ErrorMonitor = new ErrorMonitor({});

  getColor(value: string) {
    return ErrorMonitorTag.getColor(value as ErrorMonitorEnum);
  }

  getDescription(value: string) {
    return ErrorMonitorTag.getDescription(value as ErrorMonitorEnum);
  }

  getErrorMonitor() {
    if (!this.id) return;

    ErrorMonitorService.getById(this.id)
      .then((response) => {
        this.errorMonitor = response;
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  mounted() {
    this.getErrorMonitor();
  }

  close() {
    this.$emit('update:closeModal');
  }
}
